import { composeIO } from 'react-compose-io'
import { controleComissaoHistoricoIO } from './ControleComissaoHistorico.IO'
import { ControleComissaoHistoricoView } from './ControleComissaoHistorico.View'

export const ControleComissaoHistorico = composeIO(ControleComissaoHistoricoView, controleComissaoHistoricoIO)
